import Welcome from './pages/Welcome';
import { Switch, Route } from 'react-router-dom';
import DefaultLayout from './pages/layouts/Default';
import LoginLayout from './pages/layouts/Login';
import QoCIpcafAssessment from './pages/qoc/QoCIpcafAssessment';
import Login                from './pages/Login';
import ResetPassword        from './pages/ResetPassword';
import Register             from './pages/Register';
import Facilities           from './pages/Facilities';
import User                 from './pages/user/User';
import Role                 from './pages/user/Role';
import Profile              from './pages/user/Profile';
import QoCIpcafAnalytics from './pages/qoc/QoCIpcafAnalytics';
import QoCPeriodComparison   from './pages/qoc/QoCPeriodComparison';
import QoCStandardSetup      from './pages/qoc/QoCStandardSetup';
import QoCAssessment         from './pages/qoc/QoCAssessment';
import QoCAssessmentImport   from './pages/qoc/QoCAssessmentImport';
import QoCCAP                from './pages/qoc/QoCCAP';
import QoCTeamRegistry       from './pages/qoc/QoCTeamRegistry';
import QoCFacilityProfile    from './pages/qoc/QoCFacilityProfile';
import QoCFacilityProfileDashboard from './pages/qoc/QoCFacilityProfileDashboard';
import QoCSMTDashboard from './pages/qoc/QoCSMTDashboard';
import QoCDashboard          from './pages/qoc/QoCDashboard';
import QoCCompliance         from './pages/qoc/QoCCompliance';
import QoCExecutiveDashboard from './pages/qoc/QoCExecutiveDashboard';
import QoCFacilityReport     from './pages/qoc/QoCFacilityReport';
import DashboardBuilder      from './pages/qoc/DashboardBuilder';
import QoCSchedules          from './pages/qoc/QoCSchedules';
import QoCApproval           from './pages/qoc/QoCApproval';
import QoCPeriods            from './pages/qoc/QoCPeriods';
import QoCKPIs               from './pages/qoc/QoCKPIs';
import QoCCustomerSurveys    from './pages/qoc/QoCCustomerSurveys';
import QoCQualityIndex       from './pages/qoc/QoCQualityIndex';
import QoCUserManual         from './pages/qoc/QoCUserManual';
import QoCHIESync            from './pages/qoc/QoCHIESync';
import QoCFacilityCoordinates from './pages/qoc/QoCFacilityCoordinates';
import QoCAccessControl      from './pages/qoc/QoCAccessControl';
import QoCPublicSurvey       from './pages/qoc/QoCPublicSurvey';
import UserActivityReport from './pages/qoc/UserActivityReport';
import QoCAwards         from './pages/qoc/QoCAwards';
import QoCPrograms       from './pages/qoc/QoCPrograms';
import QoCCollectorPortal from './pages/qoc/QoCCollectorPortal';
import QoCCollectorForm    from './pages/qoc/QoCCollectorForm';
import QoCPublicSurveyForm from './pages/qoc/QoCPublicSurveyForm';
import QoCSurveyBuilder  from './pages/qoc/QoCSurveyBuilder';
import QoCSurveyList    from './pages/qoc/QoCSurveyList';
import QoCSurveyForm    from './pages/qoc/QoCSurveyForm';
import QoCProgramProfile from './pages/qoc/QoCProgramProfile';
import QoCJudgePortal           from './pages/qoc/QoCJudgePortal';
import QoCFacilityNominations  from './pages/qoc/QoCFacilityNominations';
import QoCOnlineUsers from './pages/qoc/QoCOnlineUsers';
import QoCNavManager  from './pages/qoc/QoCNavManager';
import QoCAYSAdmin       from './pages/qoc/QoCAYSAdmin';
import QoCAYSScorecard   from './pages/qoc/QoCAYSScorecard';
import QoCAYSAnalytics   from './pages/qoc/QoCAYSAnalytics';
import MeFrameworks      from './pages/me/MeFrameworks';
import MeFrameworkDetail from './pages/me/MeFrameworkDetail';
import MeAssignments     from './pages/me/MeAssignments';
import MeProgressCapture from './pages/me/MeProgressCapture';
import MeVerification    from './pages/me/MeVerification';
import MeDashboard       from './pages/me/MeDashboard';
import MeSdgReport       from './pages/me/MeSdgReport';
import MoHReportAdmin    from './pages/moh-report/MoHReportAdmin';
import MoHReportDashboard from './pages/moh-report/MoHReportDashboard';
import MoHReportDataEntry from './pages/moh-report/MoHReportDataEntry';
import MoHReportGenerate from './pages/moh-report/MoHReportGenerate';
import QoCSurveyReviewQueue from './pages/qoc/QoCSurveyReviewQueue';
import QoCSurveyTemplateLibrary from './pages/qoc/QoCSurveyTemplateLibrary';

export default function Routes() {
    return (
        <Switch>
            {/* Public survey — no login required */}
            <Route exact path="/qoc/survey"         component={QoCPublicSurvey} />
            <Route exact path="/qoc/survey/select"  component={QoCPublicSurvey} />
            <Route exact path="/qoc/survey/:type"   component={QoCPublicSurvey} />
            <Route exact path="/survey"             component={QoCPublicSurvey} />
            <Route exact path="/survey/select"      component={QoCPublicSurvey} />
            <Route path="/survey/portal/:email" component={QoCCollectorPortal} />
            <Route path="/survey/portal" component={QoCCollectorPortal} />
            <Route exact path="/survey/:type"       component={QoCPublicSurvey} />
            <Route path="/survey/collect/:token"   component={QoCCollectorForm} />
            <Route path="/survey/public/:token"    component={QoCPublicSurveyForm} />
            <Route path="/survey/portal/:email"    component={QoCCollectorPortal} />
            <Route path="/survey/portal"           component={QoCCollectorPortal} />
            <Route path="/survey/portal/:email" component={QoCCollectorPortal} />
            <Route path="/survey/portal" component={QoCCollectorPortal} />
            <Route path="/survey/collect/:token"    component={QoCCollectorForm} />
            <Route path="/survey/public/:token"     component={QoCPublicSurveyForm} />

            {/* Auth */}
            <LoginLayout path="/reset-password" component={ResetPassword} />
            <LoginLayout path="/register" component={Register} />
            <LoginLayout path="/" exact component={Login} />

            {/* Admin */}
            <DefaultLayout path="/profile"    component={Profile} />
            <DefaultLayout path="/users"      component={User} />
            <DefaultLayout path="/roles"      component={Role} />
            <DefaultLayout path="/facilities" component={Facilities} />

            {/* QoC */}
            <DefaultLayout path="/qoc/standards"           component={QoCStandardSetup} />
            <DefaultLayout path="/welcome" component={Welcome} exact/>
            <DefaultLayout path="/qoc/assessments"         component={QoCAssessment} />
            <DefaultLayout path="/qoc/assessment-import"   component={QoCAssessmentImport} />
            <DefaultLayout path="/qoc/approval"            component={QoCApproval} />
            <DefaultLayout path="/qoc/cap"                 component={QoCCAP} />
            <DefaultLayout path="/qoc/team-registry"       component={QoCTeamRegistry} />
            <DefaultLayout path="/qoc/facility-profile"    component={QoCFacilityProfile} />
            <DefaultLayout path="/qoc/facility-profile-dashboard" component={QoCFacilityProfileDashboard} />
            <DefaultLayout path="/qoc/smt-dashboard" component={QoCSMTDashboard} />
            <DefaultLayout path="/qoc/analytics"           component={QoCDashboard} />
            <DefaultLayout path="/qoc/compliance"          component={QoCCompliance} />
            <DefaultLayout path="/qoc/kpis"                component={QoCKPIs} />
            <DefaultLayout path="/qoc/surveys"             component={QoCCustomerSurveys} />
            <DefaultLayout path="/qoc/quality-index"       component={QoCQualityIndex} />
            <DefaultLayout path="/qoc/executive-dashboard" component={QoCExecutiveDashboard} />
            <DefaultLayout path="/qoc/facility-report"     component={QoCFacilityReport} />
            <DefaultLayout path="/qoc/custom-dashboard"    component={DashboardBuilder} />
            <DefaultLayout path="/qoc/period-comparison"   component={QoCPeriodComparison} />
            <DefaultLayout path="/qoc/periods"             component={QoCPeriods} />
            <DefaultLayout path="/qoc/schedules"           component={QoCSchedules} />
            <DefaultLayout path="/qoc/access-control"      component={QoCAccessControl} />
            <DefaultLayout path="/qoc/hie-sync"            component={QoCHIESync} />
            <DefaultLayout path="/qoc/user-manual"         component={QoCUserManual} />
            <DefaultLayout path="/qoc/facility-coordinates"         component={QoCFacilityCoordinates} />
              <DefaultLayout path="/qoc/online-users" component={QoCOnlineUsers} />
            <DefaultLayout path="/qoc/nav-manager"  component={QoCNavManager} />
            <DefaultLayout path="/qoc/online-users" component={QoCOnlineUsers} />
            <DefaultLayout path="/qoc/nav-manager"  component={QoCNavManager} />
            <DefaultLayout path="/qoc/activity-trail"         component={UserActivityReport} />
            <DefaultLayout path="/qoc/awards"                component={QoCAwards} />
            <DefaultLayout path="/qoc/programs"               component={QoCPrograms} />
            <DefaultLayout path="/qoc/survey-builder"   component={QoCSurveyBuilder} />
            <DefaultLayout path="/qoc/programs/:id/profile" component={QoCProgramProfile} />
            <DefaultLayout path="/qoc/survey-builder"    component={QoCSurveyBuilder} />
            <DefaultLayout path="/qoc/my-surveys"        component={QoCSurveyList} />
            <DefaultLayout path="/qoc/programs/:id/profile" component={QoCProgramProfile} />
            <DefaultLayout path="/qoc/judge-portal"           component={QoCJudgePortal} />
            <DefaultLayout path="/qoc/nominations"             component={QoCFacilityNominations} />
            <DefaultLayout path="/qoc/ays/admin"            component={QoCAYSAdmin} />
            <DefaultLayout path="/qoc/ays/scorecard"        component={QoCAYSScorecard} />
            <DefaultLayout path="/qoc/ays/analytics"        component={QoCAYSAnalytics} />
            <DefaultLayout path="/qoc/ipcaf-analytics" component={QoCIpcafAnalytics} />
            
            <DefaultLayout path="/qoc/ipcaf"  component={QoCIpcafAssessment} />
            <DefaultLayout path="/qoc/survey-review-queue" component={QoCSurveyReviewQueue} />
<DefaultLayout path="/qoc/survey-templates" component={QoCSurveyTemplateLibrary} />
            {/* M&E Tracker */}
            <DefaultLayout path="/me/frameworks/:id/structure" component={MeFrameworkDetail} />
            <DefaultLayout path="/me/assignments" component={MeAssignments} />
            <DefaultLayout path="/me/capture" component={MeProgressCapture} />
            <DefaultLayout path="/me/verify" component={MeVerification} />
            <DefaultLayout path="/me/dashboard" component={MeDashboard} />
            <DefaultLayout path="/me/sdg-report" component={MeSdgReport} />
            <DefaultLayout path="/me/frameworks" component={MeFrameworks} />
            {/* MoH Reporting */}
            <DefaultLayout path="/moh-report/generate" component={MoHReportGenerate} />
            <DefaultLayout path="/moh-report/data" component={MoHReportDataEntry} />
            <DefaultLayout path="/moh-report/dashboard" component={MoHReportDashboard} />
            <DefaultLayout path="/moh-report/admin" component={MoHReportAdmin} />

            {/* Fallback */}
            <LoginLayout component={Login} />
        </Switch>
    );
}


